export enum ProviderInvoiceDetailSourceEnums {
  purchaseOrder = 1,
  inventoryEntry = 2,
  others = 3
}
